angular.module('smartorg.r6.mgmts.calcEngineLog').directive("calculationEngineLog", [function () {
        return {
            restrict: 'E',
            template: require('../../template/calculation-engine-log.html'),
            transclude: true,
            scope: {
                astro: '=?'
            },
            link: function (scope) {
                scope.$on('manage:FetchCalculationEngineLog', function () {
                    scope.numLinesFromBottom = 100;
                    scope.fetch(); //shows bottom 1000 lines of log by default
                    scope.$apply();
                });
                scope.fetch = function () {
                    setTimeout(function () {
                        scope.astro.fetchCalculationEngineLog(scope.numLinesFromBottom).then(function (response) {
                            format(atob(decodeURIComponent(response.EncodedLog).replace(/\s/g, '')));
                            scope.$apply();
                        });
                    });
                };
                var format = function (lines) {
                    var lineArray = lines.split('\n');
                    scope.logLinesFetched = [];
                    for (var i = 0; i < lineArray.length; i++) {
                        var isError = false;
                        var isTab = false;
                        isTab = lineArray[i].indexOf(' ') == 0;
                        if (lineArray[i].indexOf('ERROR') !== -1 ||
                            lineArray[i].indexOf(" at ") !== -1) {
                            isError = true;
                        }
                        scope.logLinesFetched.push({
                            "line": lineArray[i],
                            "tab": isTab,
                            "error": isError
                        });
                    }
                };
                scope.back = function () {
                    scope.$emit('workbench:back');
                };
            }
        };
    }]);
//# sourceMappingURL=calculation-engine-log-directive.js.map


// WEBPACK FOOTER //
// ./app/widgets/management/calculation-engine-log/app/js/plumbing/calculation-engine-log-directive.js